export default function Pill({
  label,
  tone = "gray",
  onClick,
}: {
  label: string;
  tone?: "orange" | "green" | "gray" | "red" | "blue" | "amber";
  onClick?: () => void;
}) {
  const toneMap = {
    orange: "bg-orange-50 text-orange-700 ring-orange-200",
    green: "bg-green-50 text-green-700 ring-green-200",
    gray: "bg-gray-50 text-gray-700 ring-gray-200",
    red: "bg-red-50 text-red-700 ring-red-200",
    blue: "bg-blue-50 text-blue-700 ring-blue-200",
    amber: "bg-amber-50 text-amber-800 ring-amber-200",
  } as const;

  return (
    <span
      onClick={onClick}
      className={[
        "inline-flex items-center rounded-full px-3 py-1 text-sm font-medium ring-1",
        toneMap[tone],
        onClick ? "cursor-pointer hover:opacity-90" : "",
      ].join(" ")}
      role={onClick ? "button" : undefined}
    >
      {label}
    </span>
  );
}